export const movingStrategies = {
  ADD_STEPS_TO_YES: 'addStepsToYes',
  ADD_STEPS_TO_NO: 'addStepsToNo',
  MERGE_PATH_STRATEGY: 'mergePathStrategy',
  LEAVE_BOTH_PATHS_SPLIT_STRATEGY: 'leaveBothPathsSplitStrategy',
  KEEP_ONLY_YES_PATH_STRATEGY: 'keepOnlyYesPathStrategy',
  KEEP_ONLY_NO_PATH_STRATEGY: 'keepOnlyNoPathStrategy',
  DELETE_BOTH_PATH_STRATEGY: 'deleteBothPathStrategy',
  LEAVE_AFTER_MERGE_STRATEGY: 'leaveAfterMergeStrategy',
} as const;

export type MovingStrategies =
  (typeof movingStrategies)[keyof typeof movingStrategies];

// How to handle the following steps when a goal/condition move would attach
// them after a "Go To" step, where they could never be reached
export const unreachableStepsResolutions = {
  REMOVE: 'remove',
  NEW_BRANCH: 'newBranch',
} as const;

export type UnreachableStepsResolutions =
  (typeof unreachableStepsResolutions)[keyof typeof unreachableStepsResolutions];

export const deleteStrategies = {
  MERGE_PATH_STRATEGY: 'mergePathStrategy',
  LEAVE_BOTH_PATHS_SPLIT_STRATEGY: 'leaveBothPathsSplitStrategy',
  KEEP_ONLY_YES_PATH_STRATEGY: 'keepOnlyYesPathStrategy',
  KEEP_ONLY_NO_PATH_STRATEGY: 'keepOnlyNoPathStrategy',
  KEEP_STEPS_AFTER_MERGE_BRANCHES: 'keepStepsAfterMergeBranches',
  DELETE_ALL_STEPS_AFTER_CONDITION: 'deleteAllStepsAfterCondition',
} as const;

export type DeleteStrategies =
  (typeof deleteStrategies)[keyof typeof deleteStrategies];
